import { useEffect } from 'react';

import { useRouter } from 'next/router';

interface PageEventProps {
  event: string;
  page: string;
}

export const pageView = (url: string) => {
  const pageEvent: PageEventProps = {
    event: 'pageview',
    page: url,
  };
  dataLayer && dataLayer.push(pageEvent);
};

export const GTMPageView = () => {
  const router = useRouter();

  // nextjs bug: https://github.com/vercel/next.js/issues/11639
  useEffect(() => {
    if (!router?.asPath?.includes('?')) {
      pageView(router?.asPath);
    }
  }, []);

  useEffect(() => {
    router.events.on('routeChangeComplete', pageView);
    return () => {
      router.events.off('routeChangeComplete', pageView);
    };
  }, [router]);

  return null;
};
